(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lc22-duo-trust-stars"] && !Shopify.designMode) return;
  try {
    function initLc22DuoTrust(root) {
    const badge = root.querySelector('.jdgm-prev-badge');
    const rating = Number(badge?.dataset.averageRating);
    const count = Number(badge?.dataset.numberOfReviews);
    if (!Number.isFinite(rating) || !Number.isFinite(count) || rating <= 0 || count <= 0) return;

    const ratingText = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
    const countText = new Intl.NumberFormat('fr-FR').format(count);
    const word = rating >= 4.5 ? 'Excellent' : rating >= 4 ? 'Très bien' : rating >= 3 ? 'Bien' : 'Avis clients';
    root.querySelectorAll('[data-lc22-star]').forEach((tile) => {
      const fill = Math.max(0, Math.min(100, (rating - Number(tile.dataset.lc22Star)) * 100));
      tile.style.setProperty('--lc22-star-fill', `${fill}%`);
    });
    root.querySelector('[data-lc22-rating]').textContent = `${ratingText}/5`;
    root.querySelector('[data-lc22-rating-word]').textContent = word;
    root.querySelector('[data-lc22-review-count]').textContent = `· ${countText} avis`;
    const row = root.querySelector('[data-lc22-duo-trust-row]');
    row.setAttribute('aria-label', `${ratingText} sur 5, ${countText} avis sur le masque`);
    root.querySelector('[data-lc22-duo-trust-source]').hidden = true;
    row.hidden = false;
  }
  document.querySelectorAll('[data-lc22-duo-trust]').forEach(initLc22DuoTrust);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lc22-duo-trust]').forEach(initLc22DuoTrust);
  });
  } catch(e) { console.error(e); }
})();

})();
